import classNames from 'classnames';

import { Button } from '../../Button/Button';

import basketStyles from '../Basket.module.css';

const GiftWrappingSkeletonLoader = () => {
  return (
    <div className={classNames(basketStyles.card, basketStyles.grey)} aria-hidden>
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex flex-1 items-center gap-3">
          <div className="flex flex-1 items-center gap-3">
            <Button variant="tertiary" size="m" showSkeletonLoader />
            <span className="animate-thin-glow text-nowrap">xxxxxxxxx xxxxxxxxx</span>
          </div>
        </div>
        <Button variant="tertiary" size="s" showSkeletonLoader>
          <span className="invisible">xxxx xxxxxx</span>
        </Button>
      </div>
    </div>
  );
};

export default GiftWrappingSkeletonLoader;
